import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { usePoll } from "./usePoll";

export function useJob(onDone, okMsg) {
  const [job, setJob] = useState(null);
  const busy = !!job && ["queued", "running"].includes(job.status);
  usePoll(async () => {
    const { data } = await api.get(`/media-jobs/${job.id}`);
    setJob(data);
    if (data.status === "completed") { if (okMsg) toast.success(okMsg); onDone?.(data); }
    if (data.status === "failed") toast.error(data.error || "Something went wrong");
  }, busy, 3000);
  const start = useCallback((id) => setJob({ id, status: "queued", progress: 0 }), []);
  return [job, start, busy];
}

export function useAuthImage(path, version) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!path) { setSrc(null); return undefined; }
    let url = null;
    let live = true;
    api.get(path, { responseType: "blob" }).then((r) => { if (live) { url = URL.createObjectURL(r.data); setSrc(url); } }).catch(() => live && setSrc(null));
    return () => { live = false; if (url) URL.revokeObjectURL(url); };
  }, [path, version]);
  return src;
}
